export default __webpack_public_path__ + "static/media/deep.97523b3b.jpg";